/** A Cameroon mobile number in E.164 (+2376XXXXXXXX), or null. Accepts spaces, 237, +237 or 00237. */
export function cmPhone(input: string): string | null {
  let d = input.replace(/\D/g, '');
  if (d.startsWith('00')) d = d.slice(2);
  if (d.startsWith('237')) d = d.slice(3);
  return /^6\d{8}$/.test(d) ? '+237' + d : null;
}

/** What the sign-in field shows while typing, « 6 80 45 74 05 »; a pasted +237 or 00237 is dropped. */
export function typedPhone(input: string): string {
  let d = input.replace(/\D/g, '');
  if (d.length > 9) d = d.replace(/^(00)?237/, '');
  d = d.slice(0, 9);
  return [d.slice(0, 1), d.slice(1, 3), d.slice(3, 5), d.slice(5, 7), d.slice(7, 9)].filter(Boolean).join(' ');
}

/** « +237 6 99 12 34 56 » for display. */
export const prettyPhone = (e164: string) => e164.replace(/^\+237(\d)(\d{2})(\d{2})(\d{2})(\d{2})$/, '+237 $1 $2 $3 $4 $5');

/** Digits with the country code, from whatever the table holds (237…, +237…, 6XXXXXXXX, spaces). */
const intl = (raw: string) => { const d = raw.replace(/\D/g, '').replace(/^00/, ''); return /^6\d{8}$/.test(d) ? '237' + d : d; };

/** A tel: link the computer can dial: on a Mac with an iPhone nearby (or Windows with Phone Link) it calls through the phone, with the computer's mic. */
export const telHref = (raw: string) => 'tel:+' + intl(raw);

/** WhatsApp Desktop or Web on that number: a free call from the computer's mic is one click from the chat. */
export const waHref = (raw: string) => 'https://wa.me/' + intl(raw);
